import Modal from "bootstrap/js/dist/modal";

export default function openModalByUrl() {
    // Get URL parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Look for "modal" parameter in the URL
    const modalId = urlParams.get("modal");

    // If the parameter exists and an element with that id is found
    if (modalId) {
        const modalElement = document.getElementById(modalId);

        // Check if the element exists and has the Bootstrap modal class
        if (modalElement && modalElement.classList.contains("modal")) {
            // Create a Bootstrap modal instance and show it
            const bootstrapModal = new Modal(modalElement);
            bootstrapModal.show();
        }
    }
}
